import CiqGridViewWrapper from "components/ciq-grid-view-wrapper";
import useSubmittalTrackedData from "./hooks/submittal-tracked-data";
import useSubmittalTrackedGridConfig from "./hooks/submittal-tracked-grid-config";
import { useContext, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { getRowId } from "utils/grid-utils";
import { FilterChipComponentRef } from "entity-app/shared-components/log-render-components/filter-chip-component";
import { calculateLogPageStats } from "components/ciq-log-page-header";
import { FeatureTypes } from "entity-app/constants";
import SubmittalUntrackedHeaderComponent from "./components/header-component";
import MoveTrackedSubmittalModal from "./modals/move-tracked-submittal-modal";
import { ProjectPermissionEnum } from "constants/index";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";

function SubmittalLogUntracked() {
  const gridRef = useRef<AgGridReact<any>>(null);
  const filterChipRef = useRef<FilterChipComponentRef>(null);

  const [selectedRows, setSelectedRows] = useState<Array<any> | null>(null);
  const [submittalsToMoveTracked, setSubmittalsToMoveTracked] = useState<any[]>(
    []
  );
  const [showTrackSubmittalModal, setShowTrackSubmittalModal] = useState(false);

  const { tokenContents } = useContext(ProjectContext);

  const cannotEditUnTracked = isPermissionNotGrantted(
    ProjectPermissionEnum.EditUnTracked,
    tokenContents?.role ?? ""
  );

  const pageData = useSubmittalTrackedData();

  const { gridDefaultColDef, gridColumnDefs } = useSubmittalTrackedGridConfig();

  const [statsData, setStatsData] = useState<{
    displayCount: number;
    filterName: undefined | string;
  }>();

  return (
    <>
      <CiqGridViewWrapper
        headerComponent={
          <SubmittalUntrackedHeaderComponent
            selectedRows={selectedRows}
            onOpenMoveTrackedModal={(submittals) => {
              setSubmittalsToMoveTracked(submittals);
              setShowTrackSubmittalModal(true);
            }}
            gridRef={gridRef}
            filterChipRef={filterChipRef}
            pageData={pageData}
            statsData={statsData}
          />
        }
        gridInfo={{
          gridRef,
          columnDefs: gridColumnDefs,
          rowData: pageData.entityList,
          defaultColDef: gridDefaultColDef,
          rowHeight: 62,
          getRowId: getRowId, // After refetch the rowdata ,It help to persist Scroll Bar
          readOnlyEdit: true,
          singleClickEdit: true,
          stopEditingWhenCellsLoseFocus: true,
          context: {
            openMoveTrackedModal: (submittals: any[]) => {
              setSubmittalsToMoveTracked(submittals);
              setShowTrackSubmittalModal(true);
            },
            cannotEditUnTracked
          },
          disableResizingAutoWidth: true,
          onFilterChanged: () => {
            filterChipRef.current?.onFilterApplied();
            setStatsData(
              calculateLogPageStats({
                gridRef,
                featureTypeId: FeatureTypes.SUBMITTALS
              })
            );
            gridRef.current?.api?.deselectAll();
          },
          onSelectionChanged: () => {
            setSelectedRows(gridRef?.current?.api?.getSelectedRows() || null);
          }
        }}
      />
      <MoveTrackedSubmittalModal
        open={showTrackSubmittalModal}
        onSuccess={() => {
          setShowTrackSubmittalModal(false);
          setSubmittalsToMoveTracked([]);
          pageData.fetchLogData();
        }}
        onClose={() => {
          setShowTrackSubmittalModal(false);
          setSubmittalsToMoveTracked([]);
        }}
        featureInstances={submittalsToMoveTracked}
      />
    </>
  );
}

export default SubmittalLogUntracked;
